import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import style from '../css/ServiceHistory.module.css';
import Navbar from '../navigation/Navbar';
import axios from 'axios';
import { FaCircleCheck } from 'react-icons/fa6';
import HeaderBar from '../components/HeaderBar';
import { FaHome } from 'react-icons/fa';

function ServiceHistory() {
	const [services, setServices] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');
	const [agents, setAgents] = useState({}); // State to store agents' details by service
	const navigate = useNavigate();

	// Fetch user email from localStorage
	const userEmail = JSON.parse(localStorage.getItem('user'))?.email;

	// Fetch services based on the user's email
	useEffect(() => {
		if (!userEmail) {
			navigate('/');
			return;
		}

		const fetchServices = async () => {
			try {
				const response = await axios.get(
					'https://hometech-repairs.in/customerDB/FetchAllBooking.php',
					{
						params: { email: userEmail },
					}
				);
				if (response.data.status) {
					setServices(response.data.data);
				} else {
					setError('No services found');
				}
			} catch (err) {
				setError('Failed to fetch services. Please try again later.');
			} finally {
				setLoading(false);
			}
		};

		fetchServices();
	}, [userEmail, navigate]);

	// Fetch agent details for each service and store them in the agents state
	useEffect(() => {
		const fetchAgentDetails = async (agentId) => {
			try {
				const response = await fetch(
					`https://hometech-repairs.in/homeTech/FetchAgent.php?id=${agentId}`
				);
				const result = await response.json();
				if (result.status) {
					setAgents((prevAgents) => ({
						...prevAgents,
						[agentId]: result.data, // Store agent details by agentId
					}));
				}
			} catch (err) {
				console.error('Error fetching agent details:', err);
			}
		};

		// Call the fetchAgentDetails function for each unique agent_id
		services.forEach((service) => {
			if (service.agent_id && !agents[service.agent_id]) {
				fetchAgentDetails(service.agent_id);
			}
		});
	}, [services, agents]);

	return (
		<div>
			<HeaderBar
				text={'Service History'}
				icon={<FaHome color="black" size={20} />}
				navi="/dashboard"
			/>

			<div className={style.main}>
				{loading ? (
					<p>Loading...</p>
				) : error ? (
					<p>{error}</p>
				) : (
					<div>
						{services.length > 0 ? (
							<div className={style.services}>
								{services.map((service, index) => {
									const agent = agents[service.agent_id]; // Get agent details for this service
									return (
										<div key={index} className={style.serviceCard}>
											<p className={style.date}>
												{new Date(service.date).toLocaleDateString('en-GB')}
											</p>

											<p className={style.orNbr}>{service.order_number}</p>
											<div className={style.rows}>
												<FaCircleCheck
													color={
														service.status === 'Created'
															? 'green'
															: service.status === 'Accepted'
															? 'green'
															: service.status === 'Work in progress'
															? 'green'
															: service.status === 'Completed'
															? 'green'
															: service.status === 'Cancelled'
															? 'orangered'
															: 'orange'
													}
												/>
												<p>Booking Created</p>
											</div>
											{/* <div className={style.side}>
												<p>Name: {service.name}</p>
												<p>
													Phone:
													{service.phone
														? ` ****${service.phone.slice(-4)}`
														: 'Not Available'}
												</p>
											</div> */}

											<div className={style.side}>
												<div className={style.agentDetails}>
													<p>Name: {service.name}</p>
													<p>
														Phone:{' '}
														{service.phone
															? ` ****${service.phone.slice(-4)}`
															: 'Not Available'}
													</p>
												</div>
											</div>

											<div className={style.rows}>
												<FaCircleCheck
													color={
														service.status === 'Created'
															? 'orange'
															: service.status === 'Accepted'
															? 'green'
															: service.status === 'Work in progress'
															? 'green'
															: service.status === 'Completed'
															? 'green'
															: service.status === 'Cancelled'
															? 'orangered'
															: 'orange'
													}
												/>
												<p>
													{service.status === 'Created'
														? 'Waiting to accept'
														: 'Accepted'}
												</p>
											</div>
											{service.status === 'Cancelled' ? null : (
												<div className={style.side}>
													{agent && (
														<div className={style.agentDetails}>
															<p>Name: {agent.name}</p>
															<p>Phone: {agent.phone}</p>
														</div>
													)}
												</div>
											)}

											<div className={style.rows}>
												<FaCircleCheck
													color={
														service.status === 'Created'
															? 'orange'
															: service.status === 'Accepted'
															? 'orange'
															: service.status === 'Work in progress'
															? 'green'
															: service.status === 'Completed'
															? 'green'
															: service.status === 'Cancelled'
															? 'orangered'
															: 'orange'
													}
												/>
												<p>Work in progress</p>
											</div>

											<div className={style.rows}>
												<FaCircleCheck
													color={
														service.status === 'Created'
															? 'orange'
															: service.status === 'Accepted'
															? 'orange'
															: service.status === 'Work in progress'
															? 'orange'
															: service.status === 'Completed'
															? 'green'
															: service.status === 'Cancelled'
															? 'orangered'
															: 'orange'
													}
												/>
												<p>
													{service.status === 'Cancelled'
														? 'Cancelled'
														: 'Completed'}
												</p>
											</div>

											{service.status === 'Completed' && (
												<Link
													className={style.invoice}
													to={`/invoice/${service.order_number}`}
												>
													View Invoice
												</Link>
											)}
										</div>
									);
								})}
							</div>
						) : (
							<p>No upcoming services found.</p>
						)}
					</div>
				)}
			</div>
		</div>
	);
}

export default ServiceHistory;
